import { z } from "zod";

export const GetPotentialPayersArgsSchema = z.object({
  patient_id: z.number(),
  zip_code: z.string(),
});

export const PotentialPayerSchema = z.object({
  copay_consent: z.boolean(),
  eligibility_check_id: z.string(),
  id: z.number(),
  medicare: z.boolean(),
  name: z.string(),
});

export type GetPotentialPayersArgs = z.infer<typeof GetPotentialPayersArgsSchema>;
export type PotentialPayer = z.infer<typeof PotentialPayerSchema>;
